import { z } from 'zod'

export const UpdateLocationSchema = z.object({
  latitude: z.number().min(-90).max(90),
  longitude: z.number().min(-180).max(180),
  accuracy: z.number().min(0).max(5000).optional(),
  altitude: z.number().optional(),
  speed: z.number().min(0).max(120).optional(),
  heading: z.number().min(0).max(360).optional(),
  timestamp: z
    .string()
    .optional()
    .refine(value => !value || !Number.isNaN(Date.parse(value)), 'Invalid ISO timestamp'),
  source: z.enum(['web', 'mobile', 'desktop']).optional()
})

export type UpdateLocationInput = z.infer<typeof UpdateLocationSchema>
